export default "__VITE_ASSET__B6LM2eU6__"